var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6067_8191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9797 4.25238L6.41794 9.36543C5.32229 10.2176 4.43359 12.0315 4.43359 13.4072L4.43359 22.428C4.43359 25.2524 6.73446 27.5654 9.55881 27.5654L23.6562 27.5654C26.4806 27.5654 28.7814 25.2524 28.7814 22.4402L28.7814 13.5776C28.7814 12.1046 27.7953 10.2176 26.5901 9.3776L19.0666 4.1063C17.3623 2.91325 14.6232 2.97412 12.9797 4.25238Z",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6094 22.6961V19.0439",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6067_8191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.feb3f2f90e8fcd0907d6ab28959bb57f.svg";
export { ForwardRef as ReactComponent };